export default __webpack_public_path__ + "static/char-v-15-214510ba78832baa892f6777a1abbfdc.mp4";